/* eslint-disable indent */
import React from 'react'
import Toast from 'react-bootstrap/Toast'
import ToastContainer from 'react-bootstrap/ToastContainer'
export declare type ToastPosition = 'top-start' | 'top-center' | 'top-end' | 'middle-start' | 'middle-center' | 'middle-end' | 'bottom-start' | 'bottom-center' | 'bottom-end';

interface props {
  show: boolean
  setShow: React.Dispatch<React.SetStateAction<boolean>>
  position?: ToastPosition
  headerText: string
  bodyText: string
  textColor: string
}
const BasicExample: React.FC<props> = ({ show, setShow, position, headerText, bodyText, textColor }) => {
  return (
    <ToastContainer className='mt-5 me-5' position={position}>
      <Toast delay={10000} onClose={() => setShow(false)} show={show} autohide style={{ width: '400px', height: '100px', fontSize: '1rem' }}>
        <Toast.Header closeLabel='Close'>
          <strong className="me-auto" style={{ color: textColor }}>{headerText}</strong>
        </Toast.Header>
        <Toast.Body>{bodyText}</Toast.Body>
      </Toast>
    </ToastContainer>
  )
}

export default BasicExample